import React from "react";
import "./Page.css";
import useStore from "../store.js";

import Button from "../components/Button/Button.js";
import AudioPlayer from "../components/AudioPlayer/AudioPlayer.js";

const Page = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const game = useStore((state) => state.game);
  const setGameState = useStore((state) => state.setGameState);
  const isHost = useStore((state) => state.isHost);
  const gameState = useStore((state) => state.gameState);
  const hasPopupBild = useStore((state) => state.hasPopupBild);

  if (!game) return null;
  return (
    <div
      className={`Page${props.className ? " " + props.className : ""}${hasPopupBild ? " withPopupButton" : ""}`}
    >
      {getLocalized("game", "Intro")?.map((intro, index) => (
        <div className="IntroBlock" key={index}>
          <h1>{intro?.AudioHeadline}</h1>
          {intro.Audio?.data && (
            <AudioPlayer
              url={
                process.env.REACT_APP_CMS_URL +
                intro.Audio.data?.attributes?.url
              }
              transcript={intro?.AudioText || null}
            />
          )}
        </div>
      ))}

      {isHost && gameState == 0 && (
        <Button onClick={() => setGameState(1)}>
          <strong>
            {" "}
            {getLocalized("texts", "starten").replaceAll("%RUNDE%", "1")}
          </strong>
        </Button>
      )}
      {props.children}
    </div>
  );
};

export default Page;
